import md5 from 'md5';
const SIGN_SECRET_KEY = '415cc;301b2f8429,4b6ba';

class Utils {
  // 获取所有url中参数
  getAllParam () {
    let searchstr = location.search.substr(1);
    if (!searchstr) {
      return {};
    }
    let paramData = {};
    searchstr.split('&').map(param => {
      let paramkv = param.split('=');
      paramData[paramkv[0]] = unescape(decodeURIComponent(paramkv[1]));
    });
    return paramData;
  }

  // 获取url中的参数
  getUrlParam (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = (window.location.search.substr(1).match(reg));  //匹配目标参数
    if (r != null) return unescape(decodeURIComponent(r[2]));
    return null; //返回参数值
  }

  // 将url和其他参数拼接返回
  withUrlParams (url, extparam = {}) {
    let withQ = /\?/ig.test(url);

    let params = [];
    let allPrams = this.getAllParam()
    for (let i in allPrams) {
      params.push(`${i}=${allPrams[i]}`);
    }
    for (let i in extparam) {
      if (extparam[i]) {
        params.push(`${i}=${extparam[i]}`);
      }
    }


    let paramStr = params.join('&');
    let flag = withQ ? '&' : '?';
    return `${url}${flag}${paramStr}`;
  }

  // 获取协议
  getAppProtocol () {
    let appProtocol = '';
    let index = navigator.userAgent.indexOf('app/')
    if (index >= 0) {
      appProtocol = navigator.userAgent.slice(index + 4)
    } else {
      appProtocol = 'wkreader'
    }
    return appProtocol;
  }

  // 根据不同环境，获得H5页面地址
  getH5StaticUrl (module, from, poscode) {
    let url = ''
    if (process.env.NODE_ENV == 'production') {
      url = `${location.protocol}//readgirl-static.zhulang.com/read_prod_sc/module/${module}.html?from_h5=${from}&extsourceid=${poscode}`
    } else if (process.env.NODE_ENV === 'pre') {
      url = `${location.protocol}//readgirl-static.zhulang.com/read_pre_sc/module/${module}.html?from_h5=${from}&extsourceid=${poscode}`
    } else {
      url = `${location.protocol}//readgirl-static.zhulang.com/read_test_sc/module/${module}.html?from_h5=${from}&extsourceid=${poscode}`
    }
    return url
  }


  // 格式化时间
  dateFormat (date, fmt) {
    var o = {
      "M+": new Date(date).getMonth() + 1, //月份 
      "D+": new Date(date).getDate(), //日 
      "h+": new Date(date).getHours(), //小时 
      "m+": new Date(date).getMinutes(), //分 
      "s+": new Date(date).getSeconds(), //秒 
      "q+": Math.floor((new Date(date).getMonth() + 3) / 3), //季度 
      "S": new Date(date).getMilliseconds() //毫秒 
    };
    if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (new Date(date).getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
  // 签名
  getSign (params) {
    let keys = Object.keys(params)
    let newData = {}
    keys.sort();
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      newData[key] = params[key]
    }
    let sign = ''
    for (let key in newData) {
      if (newData.hasOwnProperty(key)) {
        let item = newData[key];
        sign += key + item
      }
    }
    sign += SIGN_SECRET_KEY
    console.log('sign', sign)
    return md5(sign)
  }

  navToDownApp (params) {
    let u = navigator.userAgent
    if (/MicroMessenger/gi.test(u)) {
      // 如果是微信客户端打开，引导用户在浏览器中打开
      alert('请使用系统浏览器中打开')
      return
    }
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      // Android
      if (this.openApp(params.AndroidScheme)) {
        // this.openApp('en://startapp') // 通过Scheme协议打开指定APP
      } else {
        //跳转Android下载地址
        window.location.href = params.AndroidUrl
      }
    } else if (u.indexOf('iPhone') > -1) {
      if (this.openApp(params.IosScheme)) {
        // this.openApp('ios--scheme') // 通过Scheme协议打开指定APP
      } else {
        // 跳转IOS下载地址
        window.location.href = params.IosUrl
      }
    }
  }

  openApp (src) {
    // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
    // 否则打开a标签的href链接
    let ifr = document.createElement('iframe')
    ifr.src = src
    ifr.style.display = 'none'
    document.body.appendChild(ifr)
    window.setTimeout(function () {
      // 打开App后移出这个iframe
      document.body.removeChild(ifr)
    }, 2000)
  }

  isAndroid () {
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('android') > -1 || ua.indexOf('Linux') > -1 || ua.indexOf('linux') > -1;
    if (isAndroid) {
      console.log('是安卓系统')
      return true
    } else {
      console.log('IOS系统')
      return false
    }
  }

  getSourceid (sid, bookid) {
    let pathList = location.pathname.split('/')
    let path = pathList[pathList.length - 1]
    path = path.split('.')[0]
    let sourceid = `${sid}_${path}`
    if (bookid) {
      sourceid += `_book${bookid}`
    }
    return sourceid
  }

  getPage () {
    let pathList = location.pathname.split('/')
    let path = pathList[pathList.length - 1]
    path = path.split('.')[0]
    return path
  }

  // 下载APP
  iframeOpenUrl (url) {
    let iframe = document.createElement("iframe");
    let body = document.body;
    iframe.style.cssText = "display:none;width=0;height=0";
    body.appendChild(iframe);
    iframe.src = url;
  }
}

export default new Utils()


// WEBPACK FOOTER //
// ./src/common/js/utils.js